import Head from "next/head";
import React, { useState, useEffect, useRef } from "react";
import Image from "next/image";
import { WEB_URL } from "@/config/endpoints";
import IMAGES from "@/public/assets/img";
import professionalsLoan from "@/config/professionalsloan_config";
import { useRouter } from "next/router";
import AccordianFaq from "@/component/shared/accordianfaq";
import BannerCTA from "@/component/shared/machinery-loan/banner-CTA";
import BusinessLoanForm from "@/component/shared/businessLoanForm/businessLoanForm";
import DigitalProfessional from "@/component/shared/professionals-Loan/digitalProfessional";
import ProfessionalsTrust from "@/component/shared/professionals-Loan/professionalsTrust";
import LoanFeatures from "@/component/shared/professionals-Loan/loanFeatures";
import ProfessionalsAdvantage from "@/component/shared/professionals-Loan/professionals-Advantage";
import { generateFaqSchema } from "@/component/shared/faqSchema";

const ProfessionalsLoan = () => {
  const router = useRouter();
  const [mWidth, setMWidth] = useState(0);
  const faqSchema = generateFaqSchema(professionalsLoan.Faq);
  const topSectionRef = useRef(null);

  const handleWindowResize = () => {
    setMWidth(window.innerWidth);
  };

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("load", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <main className="pt-[110px]">
      <Head>
        <title>{professionalsLoan.seoData.title}</title>
        <meta
          name="description"
          content={professionalsLoan.seoData.description}
        />
        {/* OpenGraph tags */}
        <meta property="og:title" content={professionalsLoan.seoData.title} />
        <meta
          property="og:description"
          content={professionalsLoan.seoData.description}
        />
        <meta property="og:image" content={IMAGES.HOMEIMG.bigLogoNew.src} />
        <meta property="og:url" content={WEB_URL + router.asPath} />
        <link rel="canonical" href={WEB_URL + router.asPath} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqSchema)
         }}
        />
      </Head>

      <section
        ref={topSectionRef}
        className={`relative bg-no-repeat sm:bg-center bg-cover bg-bottom min-h-[450px] sm:min-h-[270px]`}
      >
        {mWidth > 768 ? (
          <Image
            priority={true}
            src={IMAGES.FreightLoan.bgBannerDesktop}
            width={1366}
            height={550}
            className="absolute inset-0 max-w-none w-full h-full"
            alt="Banner Desktop"
          />
        ) : (
          <Image
            priority={true}
            src={IMAGES.FreightLoan.bgBannerMobile}
            width={767}
            height={451}
            className="absolute inset-0 max-w-none w-full h-full"
            alt="Banner Mobile"
          />
        )}
        <div className="max-w-[1100px] mx-auto sm:px-2 relative md:gap-3 flex justify-center items-center sm:flex-col pt-3 sm:pt-5">
          <div className="w-[38%] sm:w-full">
            <Image
              src={IMAGES.professionalsLoan.professionalsDesktop}
              alt="Professionals Loan"
              width={400}
              height={365}
              fetchPriority="high"
              priority={true}
              quality={100}
              className="w-[380px] h-auto sm:w-full"
            />
            <h1 className="text-3xl md:text-3xl sm:text-xl font-medium text-[#072F5F] mt-1">
              {professionalsLoan.bannerHeading}
            </h1>
            <h2 className="text-lg md:text-lg sm:text-lg text-[#072F5F] font-medium mb-xsp">
              {professionalsLoan.subheading}
            </h2>
            <div className="bg-[#E3A003] text-center px-2 sm:px-1 py-xsp rounded-[10px] text-xs font-medium sm:text-xxs text-white w-fit">
              {professionalsLoan.btntext}
            </div>
          </div>
          <div className="w-[60%] sm:w-full pt-5 sm:pt-2 flex justify-center">
            <BusinessLoanForm pageTitle="business-loan-professionals"/>
          </div>
        </div>
      </section>
      <DigitalProfessional professionalsdata={professionalsLoan.digitalProfessional}/>
      <ProfessionalsTrust professionalsTrustData={professionalsLoan.professionalsTrustData}/>
      <ProfessionalsAdvantage professionData={professionalsLoan.professionData} advantageData={professionalsLoan.advantageData}/>
      <LoanFeatures loanFeaturesData={professionalsLoan.loanFeaturesData}/>

      <section className="bg-white sm:py-[70px] py-[100px] grid place-items-center">
        <div className="container px-3 xm:px-2">
          <div>
            <h3 className="mb-6 font-bold text-center text-lg text-secondary">
              {professionalsLoan.FaqHead}
            </h3>
          </div>
          <div className="w-full text-left bg-white">
            <div className="mx-auto max-w-[1100px] sm:w-auto">
              <AccordianFaq faqData={professionalsLoan.Faq} />
            </div>
          </div>
        </div>
      </section>
      <BannerCTA data={professionalsLoan.bannerCTA} targetRef={topSectionRef} />
    </main>
  );
};

export default ProfessionalsLoan;
